import { useEffect } from 'react';
import { workbenchStore } from '~/lib/stores/workbench';

export const PreventAccidentalTabClose = () => {
  useEffect(() => {
    function confirmExit(event: BeforeUnloadEvent) {
      event.preventDefault();

      /**
       * Based on the logic in our classic editor.
       *
       * @see https://github.com/stackblitz/stackblitz/blob/e919f6c81fc1ed673589c694097e189ffaa5005c/rails/app/frontends/editor/lifecycle/dirtyTracking.tsx#L46-L59
       */
      event.returnValue = 'Bolt is still working, are you sure you want to leave?';

      return event.returnValue;
    }

    const unsubscribeFromIsStreaming = workbenchStore.isStreaming.subscribe((isStreaming) => {
      if (isStreaming) {
        window.addEventListener('beforeunload', confirmExit);
      } else {
        window.removeEventListener('beforeunload', confirmExit);
      }
    });

    return () => {
      unsubscribeFromIsStreaming();
      window.removeEventListener('beforeunload', confirmExit);
    };
  }, []);

  return null;
};
